// Клиентская валидация шаблона имени head-ветки.
//
// Источник правды правил — backend (`validate_branch_template`), его
// 422 показываем пользователю. Здесь — лишь быстрый pre-flight, чтобы
// заблокировать кнопку «Сохранить» до похода на сервер:
//
// - hasTaskId — шаблон ОБЯЗАН содержать токен уникального id задачи
//   (`{baton_task_id}` или `{baton_task_id_short}`); без него разные
//   задачи дали бы одинаковую ветку и обратный матч отменил бы чужую.
// - unknownPlaceholders — мягкое предупреждение про плейсхолдеры, не
//   входящие в легенду API (известные — флаг приходит из GET).
//
// Список известных плейсхолдеров и какие из них task-id берём из
// ответа API — здесь ничего не хардкодим.

// Извлечь имена плейсхолдеров (без фигурных скобок) из шаблона.
// `{baton_task_id_short}` → `baton_task_id_short`. Пустые `{}` и
// вложенные/несбалансированные скобки оставляем серверной валидации.
export function extractPlaceholders(template: string): readonly string[] {
  const matches = template.match(/\{([^{}]+)\}/g) ?? [];
  return matches.map((token) => token.slice(1, -1));
}

// Содержит ли шаблон хотя бы один task-id-токен (имена task-id —
// из легенды API).
export function hasTaskIdToken(
  template: string,
  taskIdNames: readonly string[],
): boolean {
  const used = new Set(extractPlaceholders(template));
  return taskIdNames.some((name) => used.has(name));
}

// Плейсхолдеры шаблона, отсутствующие в легенде API (неизвестные).
// Дубликаты убираем, порядок первого появления сохраняем.
export function unknownPlaceholders(
  template: string,
  knownNames: readonly string[],
): readonly string[] {
  const known = new Set(knownNames);
  const seen = new Set<string>();
  const result: string[] = [];
  for (const name of extractPlaceholders(template)) {
    if (!known.has(name) && !seen.has(name)) {
      seen.add(name);
      result.push(name);
    }
  }
  return result;
}
